import Lenis from 'lenis';

let instance: Scroll;

class Scroll {
  scroll!: Lenis;
  isScrollingDisabled: boolean;

  constructor() {
    if (instance) {
      throw new Error('You can only create one instance!');
    }
    instance = this;

    this.isScrollingDisabled = false;

    this.init();
  }

  init() {
    // Initializes smooth scrolling with Lenis and integrates it with GSAP's ScrollTrigger.
    // Function to set up smooth scrolling.
    // Initialize Lenis for smooth scroll effects. Lerp value controls the smoothness.
    const lenis = new Lenis({
      lerp: 0.25,
      prevent: (node) => node.id === 'header-nav',
      autoRaf: true,
    });

    // Sync ScrollTrigger with Lenis' scroll updates.
    // lenis.on('scroll', ScrollTrigger.update);

    // Ensure GSAP animations are in sync with Lenis' scroll frame updates.
    // gsap.ticker.add((time) => {
    //   lenis.raf(time * 1000); // Convert GSAP's time to milliseconds for Lenis.
    // });

    // Turn off GSAP's default lag smoothing to avoid conflicts with Lenis.
    // gsap.ticker.lagSmoothing(0);

    this.scroll = lenis;
  }

  disableScrolling() {
    if (!this.isScrollingDisabled) {
      this.isScrollingDisabled = true;
      this.scroll.stop();
    }
  }

  enableScrolling() {
    if (this.isScrollingDisabled) {
      this.isScrollingDisabled = false;
      this.scroll.start();
    }
  }

  scrollToSection($target: JQuery<HTMLElement>, centerInView = false) {
    const offset = $target.offset();
    if (!offset) return;
    let topOffset = offset.top;

    if (centerInView) {
      // element size
      const height = $target.outerHeight() || 0;
      // viewport size
      const windowHeight = window.innerHeight;
      // calculate center position
      topOffset = topOffset - windowHeight / 2 + height / 2;
    }

    this.scroll.scrollTo(topOffset, {
      offset: centerInView ? 0 : -100,
      duration: 1.5,
      lerp: 0,
      easing: (x) => (x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2),
    });
  }
}

const SmoothScroll = new Scroll();
// allow accessing through the window
(window as any).SmoothScroll = SmoothScroll.scroll;

export default SmoothScroll;
